// ctp_download and breadcrumb_click on every template, as live's leaf_ctp_download.js and leaf_breadcrumb_click.js.
// product_id and product_name are only set on a PDP.
const productContext = () => {
  const product = window.ShopifyAnalytics?.meta?.product;
  if (!product) return { product_id: undefined, product_name: undefined };
  const variant = product.variants?.[0];
  const name = variant?.public_title ? variant.name.replace(` - ${variant.public_title}`, '') : variant?.name;
  return { product_id: String(product.id), product_name: name };
};

const push = (event, link) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, text: link.textContent.trim(), ...productContext() });
};

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const pdfLink = target.closest('a[href]');
  if (pdfLink && pdfLink.getAttribute('href').toLowerCase().includes('.pdf')) push('ctp_download', pdfLink);
  const crumbLink = target.closest('.eq-pdp-breadcrumb__link, .eq-documents-listing__crumb-link');
  if (crumbLink) push('breadcrumb_click', crumbLink);
});
